import { useState } from "react";

const STAFF_VIDEO_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_ai-shorthand/artifacts/11a65bf6d75ddbe0_XpressPrompts%20enables%20your%20staff%20to%20use%20short.%20Com.mp4";
const DEVELOPER_IMAGE_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_ai-shorthand/artifacts/aead6e015ea98699_Enable%20your%20staff%20with%20short%20command%20dictionary6.png";

export const AboutStaffVideo = () => {
  const [error, setError] = useState(false);
  return (
    <div className="mb-8" data-testid="about-staff-video-section">
      <video
        data-testid="about-staff-video"
        aria-label="XpressPrompts enables your staff to use short command prompts"
        width="1472"
        height="1088"
        className="block w-full aspect-[23/17] object-contain rounded-lg bg-[#0B0F0D]"
        autoPlay
        muted
        loop
        playsInline
        controls
        preload="metadata"
        onLoadedData={() => setError(false)}
        onPlaying={() => setError(false)}
        onError={(event) => setError(Boolean(event.currentTarget.error))}
      >
        <source src={STAFF_VIDEO_URL} type='video/mp4; codecs="avc1.640028, mp4a.40.2"' />
        <source src="/assets/about-staff-video.webm" type='video/webm; codecs="vp9, opus"' />
        Your browser does not support this video.
      </video>
      {error && <p role="alert" data-testid="about-staff-video-error" className="mt-3 text-sm text-red-700">The video couldn't load. You can open it directly below.</p>}
      <a href={STAFF_VIDEO_URL} target="_blank" rel="noopener noreferrer" data-testid="about-open-staff-video"
        className="mt-3 inline-block text-sm font-semibold text-emerald-800 underline underline-offset-4 hover:text-emerald-950 transition-colors">
        Open video
      </a>
    </div>
  );
};

export const AboutDeveloperImage = () => (
  <img
    data-testid="about-developer-image"
    src={DEVELOPER_IMAGE_URL}
    alt="A woman at a desk beside a computer displaying the XpressPrompts short-command dictionary"
    width="1448"
    height="1086"
    loading="lazy"
    decoding="async"
    className="block w-full h-auto aspect-[4/3] object-contain rounded-lg mb-8"
  />
);